export const APISequences = {
    LESSON_FINISH_AND_PATCH_PROFILE: 'lessonFinishAndPatchProfile',
    MEAL_MENUS: 'mealMenus',
};
